export const aciTransportation = {
    iconName: 'transportation',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    d: 'M18.988 16.833a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0zM8.322 16.833a1.333 1.333 0 11-2.666 0 1.333 1.333 0 012.666 0zM16.32 16.832h-8',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M18.988 16.832h2.667a1.334 1.334 0 001.333-1.333l-.295-1.772a2.667 2.667 0 00-2.63-2.228h-1.741l-2.536-3.55a2.666 2.666 0 00-2.17-1.117H4.989a2 2 0 00-2 2V12.4',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M5.654 16.83h-.666a2 2 0 01-2-2v-3.912M18.322 11.5H2.99M12.322 6.832v10M7.656 11.499V6.832',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
